import { render, staticRenderFns } from "./Invited.vue?vue&type=template&id=f70feb9c&scoped=true&"
import script from "./Invited.vue?vue&type=script&lang=js&"
export * from "./Invited.vue?vue&type=script&lang=js&"
import style0 from "./Invited.vue?vue&type=style&index=0&id=f70feb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70feb9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
